import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-banco',
  templateUrl: './add-banco.component.html',
  styleUrls: ['./add-banco.component.css']
})
export class AddBancoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
